export const PROJECT_TOPIC_LABEL_CLASS = 'site-label project-topic-label'
